// pages/ReleaseNote/styles.ts
import type {Theme} from "@mui/material/styles";

export const cardSx = (t: Theme) => ({p: t.spacing(2), borderRadius: t.spacing(1.5)} as const);
export const headerCellSx = (width?: number | string) => ({fontWeight: 600, width} as const);
export const topCellSx = {verticalAlign: "top"} as const;
